var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M240.24,289.29c79.76,0,144.65-64.88,144.65-144.64S320,0,240.24,0,95.6,64.89,95.6,144.65,160.48,289.29,240.24,289.29Zm0-229.29a84.65,84.65,0,1,1-84.64,84.65A84.74,84.74,0,0,1,240.24,60Zm284,512.38v60c-38.2,0-65.26-10.93-82.7-33.42-18.62-24-21-55.45-21-80.18,0-45.1-15.94-78.12-48.73-100.95-31.09-21.65-76.57-33.1-131.52-33.1C186.05,384.73,60,398.12,60,522.08v50.15H304.24l37.66,60H0V522.08C0,400.35,92.06,324.73,240.24,324.73c67.27,0,124.61,15.17,165.81,43.86,48.7,33.92,74.44,85.85,74.44,150.19,0,21.61,2.83,36.21,8.41,43.41C496.8,572.38,517.42,572.38,524.19,572.38Z"}))));
}

EmptyProfile.defaultProps = {"viewBox":"0 0 524.19 632.38"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
